// extracted by mini-css-extract-plugin
module.exports = {"pager":"pager_pager__ZNKoZ","prev":"pager_prev__Xz58t","next":"pager_next__1_s1H","backbtn":"pager_backbtn__sJR-9"};